import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import Image from "next/image";
import {useTranslations} from "next-intl";
import {ColletteButton} from "@collette-travel/collette-common-controls";
import { usePathname } from "@/i18n/routing";

interface SubmissionProps {
  handleClose: () => void;
  error?: boolean;
}

const wyngMessageFormats = {
  b: (chunks: React.ReactNode) => <b>{chunks}</b>,
  br: () => <br />
};

const TalkToAnExpertSubmissionMessage = ({
  handleClose,
  error = false
}: SubmissionProps) => {
  const t = useTranslations("FORMS");
  const pathname = usePathname();
  const isPdpPage = pathname.split("/").filter(Boolean).length === 4 && pathname.startsWith("/tours/");

  const newTabProps = {
          target: "_blank",
          rel: "noopener noreferrer"
        };
  return (
    <Stack
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "center",
        gap: "2.4rem",
        flexDirection: "column",
        padding: "3.2rem",
        borderRadius: "2rem"
      }}
    >
      <Typography
        variant="h2"
        component="h5"
        data-testid="ttae-submission-message-header"
      >
        {error ? t("There was an issue") : t("Thank You")}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        data-testid="ttae-submission-message-copy"
        sx={{width:"379px"}}
      >
        {error ? t("TTAE.error message") : t("TTAE.submission copy")}
      </Typography>
      {!error && !isPdpPage && 
      <Stack direction="row" alignItems="stretch" gap="2.4rem">
        <Box sx={{width: "6px",height: "142px",backgroundColor: "#96DAEA",borderRadius: "3px"}} />
        <Image
          // component="img"
          src="https://collette.widen.net/content/wxmmjyriwe/jpeg/peru-2739451.jpg?color=ffffffff&u=zzjrjm&use=yaaeo&position=c&quality=80"
          alt="travel quiz"
          width={130}
          height={130}
          style={{ borderRadius:"20px", flexShrink: 0, objectFit: "cover", display: "block" }}
        />
        <Stack justifyContent="center" alignItems="flex-start" maxWidth="379px" display="flex" gap="2.4rem" sx={{ textAlign: "left" }}>
          <Typography
            variant="subtitle1"
            component="p"
            >
              {t.rich("wyng_message", {
                ...wyngMessageFormats
              })}
            </Typography>
            <ColletteButton
            color="secondary"
            label="Start Quiz"
            testId="ttae-submission-message-close-button"
            onClick={handleClose}
            href="https://experiences.wyng.com/redirect/?experience=68a8d72109f9dcf2b099f282&media=Form%3A%20Talk%20to%20an%20Expert"
            sx={{
              // maxWidth: "9rem",
              "&:focus-visible": {
                backgroundColor: "secondary.dark"
              }
            }}
          {...newTabProps}
          />
        </Stack>
      </Stack>
      }
    </Stack>
  );
};

export default TalkToAnExpertSubmissionMessage;